export const actions = {
  login: 'LOGIN',
  logout: 'LOGOUT',
  setToast: 'SET_TOAST',
  closeToast: 'CLOSE_TOAST',
  getProducts: 'GET_PRODUCTS',
  fetchProductsStart: 'FETCH_PRODUCTS_START',
  fetchProductsSuccess: 'FETCH_PRODUCTS_SUCCESS',
  fetchProductsFailure: 'FETCH_PRODUCTS_FAILURE',
  sortProducts: 'SORT_PRODUCTS',
  togglefastDeliveryOnly: 'TOGGLE_FAST_DELIVERY_ONLY',
  toggleIncludeOutOfStock: 'TOGGLE_INCLUDE_OUT_OF_STOCK',
  toggleProcessors: 'TOGGLE_PROCESSORS',
  setPriceRange: 'SET_PRICE_RANGE',
  setRating: 'SET_RATING',
  setSearch: 'SET_SEARCH',
  resetFilters: 'CLEAR_FILTER',
  fetchCart: 'FETCH_CART',
  fetchCartSuccess: 'FETCH_CART_SUCCESS',
  fetchCartFailure: 'FETCH_CART_FAILURE',
  addToCart: 'ADD_TO_CART',
  removeFromCart: 'REMOVE_FROM_CART',
  updateCart: 'UPDATE_CART',
  fetchWishlist: 'FETCH_WISHLIST',
  fetchWishlistSuccess: 'FETCH_WISHLIST_SUCCESS',
  fetchWishlistFailure: 'FETCH_WISHLIST_FAILURE',
  addToWishlist: 'ADD_TO_WISHLIST',
  removeFromWishlist: 'REMOVE_FROM_WISHLIST',
}
